import "../Home-page.scss";
import { Grid, Typography, CircularProgress, Alert } from "@mui/material";
import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import privacyMdPath from "../markdown/privacy.md";

function PrivacyPage() {
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(privacyMdPath)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((text) => {
        // --- Manual Front-matter Parsing ---
        let parsedTitle = "Privacy Policy"; // Default title
        let rawContent = text;

        const frontMatterRegex = /^---\s*([\s\S]*?)\s*---/;
        const match = text.match(frontMatterRegex);

        if (match && match[1]) {
          const frontMatterContent = match[1];
          // Find the title line within the front matter
          const titleMatch = frontMatterContent.match(/^title:\s*(.*)$/im); // Case-insensitive, multiline
          if (titleMatch && titleMatch[1]) {
            parsedTitle = titleMatch[1].trim();
          }
          // Get content *after* the front matter block
          rawContent = text.substring(match[0].length).trim();
        }

        setTitle(parsedTitle);
        setContent(rawContent);
      })
      .catch((err) => {
        console.error("Failed to load privacy policy:", err);
        setError("Could not load the privacy policy. Please try again later.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <div style={{ justifyContent: "center", display: "flex", width: "100%" }}>
      <div style={{ padding: "20px", width: "100%" }}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} md={10}>
            <div style={{ color: "#FFFFFF", textAlign: "left" }}>
              <Typography variant="h4" gutterBottom>
                {title}
              </Typography>

              {isLoading && (
                <Grid
                  container
                  justifyContent="center"
                  style={{ padding: "40px 0" }}
                >
                  <CircularProgress color="inherit" />
                </Grid>
              )}
              {error && (
                <Alert severity="error" style={{ marginTop: "20px" }}>
                  {error}
                </Alert>
              )}
              {!isLoading && !error && (
                <Typography component="div" variant="body1">
                  <ReactMarkdown
                    rehypePlugins={[rehypeRaw]}
                    components={{
                      h2: ({ node, ...props }) => (
                        <Typography
                          variant="h5"
                          gutterBottom
                          style={{ marginTop: "24px" }}
                          {...props}
                        />
                      ),
                      h3: ({ node, ...props }) => (
                        <Typography
                          variant="h6"
                          gutterBottom
                          style={{ marginTop: "16px" }}
                          {...props}
                        />
                      ),
                      h4: ({ node, ...props }) => (
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          style={{ marginTop: "16px" }}
                          {...props}
                        />
                      ),
                      p: ({ node, ...props }) => (
                        <Typography variant="body1" paragraph {...props} />
                      ),
                      a: ({ node, ...props }) => (
                        <a style={{ color: "#BB86FC" }} {...props} />
                      ),
                      ul: ({ node, ...props }) => (
                        <ul
                          style={{ paddingLeft: "20px", marginBottom: "16px" }}
                          {...props}
                        />
                      ),
                      li: ({ node, ...props }) => (
                        <li style={{ marginBottom: "8px" }} {...props} />
                      ),
                    }}
                  >
                    {content}
                  </ReactMarkdown>
                </Typography>
              )}
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default PrivacyPage;
